<template>
  <section class="page-main-banner" data-buried="Banner">
    <h1 class="page-main-banner-title font-dt">
      AI一键生成数字人视频<br />
      专业级效果触手可及
    </h1>
    <div class="page-main-banner-sub">
      <p>
        不会拍视频也没关系。输入文字或PPT，一键就能生成高质量3D数字人视频。无需拍摄剪辑，数字人自然出镜，声音、动作、情绪全在线。企业宣传、课程讲解、
      </p>
      <p>产品推广一站式搞定。用AI做视频，不止更快，也更简单、更专业、更可控。</p>
    </div>
    <div class="page-main-banner-buttons">
      <StartBtn />
    </div>
    <div ref="videoContainer" class="page-avatar-banner-video">
      <VideoPlayer
        class="video_cover"
        :autoplay="true"
        :muted="true"
        :enable-fullscreen="false"
        :controls="false"
        :url="getFeUrl('/youyan-platform/ai-avatar-video-generation/banner/video-banner-1017.m3u8')"
        :poster="
          getFeUrl(
            '/youyan-platform/ai-avatar-video-generation/banner/banner.png?x-oss-process=image/format,webp',
          )
        "
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import VideoPlayer from '~/components/video-player/index.vue';
import { getFeUrl } from '~/utils/url';
import StartBtn from '../../components/start-btn.vue';

const videoContainer = ref<HTMLElement>();
</script>
<style lang="scss" scoped src="./styles/pc.scss"></style>
<style lang="scss" scoped src="./styles/mobile.scss"></style>
